import { useContext, useMemo } from "react";
import { AppConfigContext } from "../context";
import { buildDripVaults, DripVaultDescriptor } from "../constants/dripVaults";

/** Enabled Drip vaults for the current environment. Stable across renders. */
export const useDripVaults = (): DripVaultDescriptor[] => {
  const { solVrtMintAddress, dripHsolEnabled } = useContext(AppConfigContext);

  return useMemo(
    () => buildDripVaults({ solVrtMintAddress, dripHsolEnabled }),
    [solVrtMintAddress, dripHsolEnabled]
  );
};
